import Image from "next/image";
import { Icon } from "@ospweb/sdk-ui";
import { cn } from "utils";

export interface ThemeSymbolsProps {
  symbols: string[];
  className?: string;
  size?: number;
}

export const ThemeSymbols = ({
  symbols,
  className,
  size = 24,
}: ThemeSymbolsProps) => {
  const MAX_VISIBLE = 3;
  const visibleSymbols = symbols.slice(0, MAX_VISIBLE);
  const showMore = symbols.length > MAX_VISIBLE;

  // 计算实际宽度：
  // - 最后一个元素的 left = (显示元素数 - 1) * size * 0.75
  // - 总宽度 = left + size
  const totalElements = showMore ? MAX_VISIBLE + 1 : visibleSymbols.length;
  const width =
    totalElements > 0 ? (totalElements - 1) * size * 0.75 + size : size;

  return (
    <div
      className={cn("relative mt-2 h-6", className)}
      style={{
        width,
        height: size,
      }}
    >
      {/* symbols - 重叠布局（仅显示前3个） */}
      {visibleSymbols.map((symbol, index) => (
        <div
          key={index}
          className={cn(
            "absolute rounded-full border border-border_solid overflow-hidden flex items-center justify-center bg-background_solid_secondary",
          )}
          style={{
            width: size,
            height: size,
            left: `${index * (size * 0.75)}px`,
            zIndex: visibleSymbols.length - index,
          }}
        >
          <Image
            src={symbol}
            alt={`symbol ${index + 1}`}
            width={size}
            height={size}
            className="w-full h-full object-cover"
            unoptimized
          />
        </div>
      ))}
      {/* 更多符号 - 仅当有3个及以上币种时显示，位置紧随可见最后一个 */}
      {showMore && (
        <div
          className="absolute rounded-full border border-border_solid bg-background_white_overlay10 overflow-hidden flex items-center justify-center"
          style={{
            left: `${visibleSymbols.length * (size * 0.75)}px`,
            zIndex: 0,
            width: size,
            height: size,
          }}
        >
          <Icon
            name="dots-horizontal-rounded"
            className="text-content_secondary"
            size={size * 0.5}
          />
        </div>
      )}
    </div>
  );
};
